import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h2", null, "修改您的取貨地點資料", -1 /* HOISTED */)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", null, "如需修改取貨地點，請重新選擇", -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createVNode("label", { for: "defaultBranch" }, "取貨地點：", -1 /* HOISTED */)

import { computed, inject, ref, useCssModule } from 'vue'
import Swal from 'sweetalert2'
import { useIdentity, updateIdentity } from '@/composables/useIdentity'
import { useBranches } from '@/composables/useBranches'
import Card from '@/components/Card.vue'


export default _defineComponent({
  expose: [],
  setup(__props) {

const appConfig = app_config
const globalStyle = inject<Record<string, string>>('globalStyle')
const style = useCssModule()
const identity = useIdentity()
const branches = computed(() => (
	useBranches().value
		.filter(({ BranchID }) => (BranchID !== 0))
		.filter(({ BranchID }) => (BranchID !== 8))  //民生不顯示
		.sort((a, b) => a.BranchID - b.BranchID)
))
const branchID = ref(identity.defaultBranch)

const submit = async () => {
	if (!branchID.value || branchID.value === 0) {
		Swal.fire({
			icon: 'error',
			title: '喔噢',
			text: '請先選擇取貨地點喔',
		})
		return
	}

	try {
		await updateIdentity({
			branch: branchID.value,
		})
	} catch (e) {
		Swal.fire({
			icon: 'error',
			title: '喔噢',
			text: e.message,
		})
		return
	}

	const branchName = branches.value.find(({ BranchID: id }) => id === branchID.value).BranchName
	Swal.fire({
		icon: 'success',
		title: '修改成功',
		text: `取貨地點已修改為「${branchName}」了！提醒您以後記得至新的取貨地點取貨`,
	})
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Card, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _createVNode("div", {
        class: _unref(style).form
      }, [
        _hoisted_3,
        _withDirectives(_createVNode("select", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (branchID.value = $event)),
          class: _unref(globalStyle).inputbox,
          id: "defaultBranch"
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_unref(branches), (branch) => {
            return (_openBlock(), _createBlock("option", {
              key: branch.BranchID,
              value: branch.BranchID
            }, _toDisplayString(branch.BranchName), 9 /* TEXT, PROPS */, ["value"]))
          }), 128 /* KEYED_FRAGMENT */))
        ], 2 /* CLASS */), [
          [_vModelSelect, branchID.value]
        ])
      ], 2 /* CLASS */),
      _createVNode("p", {
        innerHTML: _unref(appConfig).group_branch_description
      }, null, 8 /* PROPS */, ["innerHTML"]),
      _createVNode("div", {
        class: _unref(globalStyle).button,
        onClick: submit
      }, "確認修改取貨點", 2 /* CLASS */)
    ]),
    _: 1 /* STABLE */
  }))
}
}

})